export default {
  notifications: false,
  documentFilter: false,
};
